import { useEffect, useState } from 'react'
import { ActivityIndicator, Platform, StyleSheet, Text } from 'react-native'

import { Stack } from '@zet/design-system/layout'
import Lottie from 'lottie-react'
import LottieView from 'lottie-react-native'

import { userFlowLoadingLottieUrl } from './constants'

const UserFlowLoading = () => {
  const [webAnimationData, setWebAnimationData] = useState<object | null>(null)

  useEffect(() => {
    if (Platform.OS !== 'web') {
      return
    }

    let isMounted = true

    fetch(userFlowLoadingLottieUrl)
      .then((response) => response.json())
      .then((data) => {
        if (isMounted) {
          setWebAnimationData(data)
        }
      })
      .catch(() => {
        if (isMounted) {
          setWebAnimationData(null)
        }
      })

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <Stack style={styles.loadingContainer}>
      <Stack style={styles.loadingContent}>
        {Platform.OS === 'web' ? (
          webAnimationData ? (
            <Lottie
              animationData={webAnimationData}
              autoPlay
              loop
              style={styles.loadingLottie}
            />
          ) : (
            <ActivityIndicator
              size="large"
              color="#832DC2"
              style={styles.loadingSpinner}
            />
          )
        ) : (
          <LottieView
            autoPlay
            loop
            source={{ uri: userFlowLoadingLottieUrl }}
            style={styles.loadingLottie}
          />
        )}
        <Text style={styles.loadingTitle}>Finding Loan Options For You</Text>
        <Text style={styles.loadingDescription}>
          We are getting the best interest rates and offers for your profile.
          This may take up to 5 minutes...
        </Text>
      </Stack>
    </Stack>
  )
}

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
    paddingVertical: 40,
  },
  loadingContent: {
    width: '100%',
    maxWidth: 360,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingDescription: {
    marginTop: 6,
    maxWidth: 328,
    fontFamily: 'THICCCBOI-Medium',
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: -0.28,
    color: '#9CA3AF',
    textAlign: 'center',
  },
  loadingLottie: {
    width: 148,
    height: 148,
  },
  loadingSpinner: {
    width: 148,
    height: 148,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingTitle: {
    marginTop: 24,
    fontFamily: 'THICCCBOI-ExtraBold',
    fontSize: 18,
    lineHeight: 24,
    letterSpacing: -0.36,
    color: '#0C0E11',
    textAlign: 'center',
  },
})

export default UserFlowLoading
